import { getNcobRedirectUrl } from 'bl/ncob/getNcobRedirectUrl.bl';
import SALON_FLAG from 'constants/salonFlag.const';
import { useSingleSalonFlag } from 'providers/SalonBasicInfo.provider';

export const useNcobRedirectUrl = ({ ncobTinyUrl, salonId }) => {
  const isNewNcob = useSingleSalonFlag(SALON_FLAG.useNewNcob);
  return getNcobRedirectUrl({ ncobTinyUrl, salonId, isNewNcob });
};
